<template>
  <v-container grid-list-xs class="d-flex justify-center align-center my-10">
    <v-card class="card-width card-radius card-shadow my-16" elevation="0">
      <v-card-title
        primary-title
        class="dark-blue white--text title font-weight-medium px-10"
        >Program Keahlian</v-card-title
      >
      <v-container>
        <v-container grid-list-xs class="py-5">
          <v-col v-for="major in majors" :key="major.url">
            <v-card
              class="card-radius card-shadow py-5 px-8"
              :style="getBackground(major.url)"
              elevation="0"
              :to="`/informasi/jurusan/${major.url}`"
            >
              <v-row align="center">
                <div class="card-text font-weight-medium">{{ major.name }}</div>
                <v-spacer></v-spacer>
                <v-icon class="hidden-sm-and-down">mdi-chevron-right</v-icon>
              </v-row>
            </v-card>
          </v-col>
        </v-container>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "Jurusan",
  data: () => ({
    majors: [
      {
        name: "DKV Konsentrasi Teknik Grafika",
        url: "teknik-grafika",
      },
      {
        name: "DKV Konsentrasi Desain Grafika",
        url: "desain-grafika",
      },
      {
        name: "Animasi 3D",
        url: "animasi-3d",
      },
      {
        name: "Animasi 2D",
        url: "animasi-2d",
      },
      {
        name: "Pengembangan Perangkat Lunak dan Gim",
        url: "pengembangan-perangkat-lunak-gim",
      },
    ],
    getBackground(major) {
      switch (major) {
        case "teknik-grafika":
          return {
            background:
              "linear-gradient(90deg, #94F4D2 -27.68%, rgba(125, 238, 197, 0) 105.42%)",
          };
        case "desain-grafika":
          return {
            background:
              "linear-gradient(90deg, #94A3F4 -27.68%, rgba(156, 172, 245, 0) 105.42%)",
          };
        case "animasi-3d":
          return {
            background:
              "linear-gradient(90deg, #FFC48D -27.68%, rgba(255, 200, 150, 0) 105.42%)",
          };
        case "animasi-2d":
          return {
            background:
              "linear-gradient(90deg, #B6B6B6 -27.68%, rgba(190, 190, 190, 0) 105.42%)",
          };
        case "pengembangan-perangkat-lunak-gim":
          return {
            background:
              "linear-gradient(90deg, #F4E594 -27.68%, rgba(255, 231, 107, 0) 105.42%)",
          };
      }
    },
  }),
};
</script>


<style scoped>
.dark-blue {
  background-color: #24305e !important;
}

.card-text {
  font-size: 1.2rem;
}

.card-radius {
  border-radius: 10px !important;
}

.card-width {
  width: 60%;
}

.card-shadow {
  box-shadow: -2px -2px 4px rgba(0, 0, 0, 0.08), 2px 2px 4px rgba(0, 0, 0, 0.08) !important;
}

@media screen and (max-width: 1251px) {
  .card-width {
    width: 70%;
  }
}

@media screen and (max-width: 800px) {
  .card-width {
    width: 83%;
  }
}

@media screen and (max-width: 600px) {
  .card-width {
    width: 100%;
  }

  .card-text {
    font-size: 1rem;
  }
}
</style>